"use strict";
// ── Overload signatures ──
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayCopyDouble = arrayCopyDouble;
exports.arrayCopyInt = arrayCopyInt;
// ── Single implementation (covers all overloads via optional params) ──
function arrayCopyDouble(sourceArray, sourceIndexOrDest, destArrayOrLength, destIndexOrLength, length) {
    var sourceArray_;
    var sourceIndex;
    var destArray;
    var destIndex;
    var length_;
    if (length !== undefined) {
        // 5-param: sourceArray, sourceIndex, destArray, destIndex, length
        sourceArray_ = sourceArray;
        sourceIndex = sourceIndexOrDest;
        destArray = destArrayOrLength;
        destIndex = destIndexOrLength;
        length_ = length;
    }
    else {
        // 3-param: sourceArray, destArray, length
        sourceArray_ = sourceArray;
        sourceIndex = 0;
        destArray = sourceIndexOrDest;
        destIndex = 0;
        length_ = destArrayOrLength;
    }
    if (sourceIndex < 0 || sourceIndex + length_ > sourceArray_.length) {
        throw new RangeError("Source indices out of bounds");
    }
    if (destIndex < 0 || destIndex + length_ > destArray.length) {
        throw new RangeError("Destination indices out of bounds");
    }
    destArray.set(sourceArray_.subarray(sourceIndex, sourceIndex + length_), destIndex);
}
// ── Single implementation (covers all overloads via optional params) ──
function arrayCopyInt(sourceArray, sourceIndexOrDest, destArrayOrLength, destIndexOrLength, length) {
    var sourceArray_;
    var sourceIndex;
    var destArray;
    var destIndex;
    var length_;
    if (length !== undefined) {
        // 5-param: sourceArray, sourceIndex, destArray, destIndex, length
        sourceArray_ = sourceArray;
        sourceIndex = sourceIndexOrDest;
        destArray = destArrayOrLength;
        destIndex = destIndexOrLength;
        length_ = length;
    }
    else {
        // 3-param: sourceArray, destArray, length
        sourceArray_ = sourceArray;
        sourceIndex = 0;
        destArray = sourceIndexOrDest;
        destIndex = 0;
        length_ = destArrayOrLength;
    }
    if (sourceIndex < 0 || sourceIndex + length_ > sourceArray_.length) {
        throw new RangeError("Source indices out of bounds");
    }
    if (destIndex < 0 || destIndex + length_ > destArray.length) {
        throw new RangeError("Destination indices out of bounds");
    }
    destArray.set(sourceArray_.subarray(sourceIndex, sourceIndex + length_), destIndex);
}
